import { render } from "./EventModule.vue?vue&type=template&id=486875cc&scoped=true"
import script from "./EventModule.vue?vue&type=script&lang=js"
export * from "./EventModule.vue?vue&type=script&lang=js"

import "./EventModule.vue?vue&type=style&index=0&id=486875cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486875cc"]])

export default __exports__